import { useEffect, useState } from "react";
import request from "project-config/services/request/request";
import { useSwitchSidebar } from "@/components/Sidebar/hooks/useSwitchSidebar";

interface IInvoiceRecordInfo {
  total: number;
  pageSize: number;
  pageNum: number;
  items: {
    invoiceOrderNumber: string;
    createDate: string;
    type: number;
    money: number;
    status: number;
    expressNumber: string;
    remarks: string;
    cancelInvoice: string;
  }[];
}
interface IInvoiceRecordProps {
  pageNo: number;
  pageSize: number;
}
export function useInitHistoryRecordInfo() {
  const { pathname } = useSwitchSidebar();
  const [invoiceHistoryRecordInfo, setInvoiceHistoryRecordInfo] =
    useState<IInvoiceRecordInfo>({
      total: 0,
      pageNum: 1,
      pageSize: 10,
      items: [],
    });
  const fetchInvoiceHistoryRecord = async (params: IInvoiceRecordProps) => {
    const { data } = await request.post(
      "/api/rendering/user/queryCompletedReceipt",
      params
    );
    if (!data) return;
    setInvoiceHistoryRecordInfo(data);
  };

  useEffect(() => {
    if (
      pathname &&
      ["/invoice/previous", "/invoice/previous/"].includes(pathname)
    ) {
      fetchInvoiceHistoryRecord({ pageSize: 10, pageNo: 1 });
    }
  }, [pathname]);

  return {
    invoiceHistoryRecordInfo,
    setInvoiceHistoryRecordInfo,
    fetchInvoiceHistoryRecord,
  };
}
